import * as React from 'react';

import { IPaymentDetails } from 'src/model/credit.model';

import './CreditsPaymentDetailsTableMobile.scss';
import LocaleFormating from 'src/translation/localeFormating';

interface ICreditsPaymentDetailsTableMobileProps {
  payment: IPaymentDetails;
}

class CreditsPaymentDetailsTableMobile extends React.Component<
  ICreditsPaymentDetailsTableMobileProps,
  any
> {
  public render() {
    const { payment } = this.props;

    return (
      <div className="rp-credits-details-table-mobile container-fluid">
        <div className="row">
          <div className="col-4">
            <h6 className="rp-credits-details-tab-mobile-header">Invoice</h6>
          </div>
          <div className="col-4">
            <h6 className="rp-credits-details-tab-mobile-header">Total AMT</h6>
          </div>
          <div className="col-4">
            <h6 className="rp-credits-details-tab-mobile-header">
              Payment AMT
            </h6>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <span>{payment.invoice.invoiceNumber}</span>
          </div>
          <div className="col-4">
            <span>{LocaleFormating.formatCurrency(payment.totalAmount)}</span>
          </div>
          <div className="col-4">
            <span>{LocaleFormating.formatCurrency(payment.paymentAmount)}</span>
          </div>
        </div>
        <div className="row rp-credit-details-tab-reason">
          <h6 className="col-12 rp-credits-details-tab-mobile-header">
            Reason for remaining balance
          </h6>
          <span className="col-12 rp-credits-p-details-italic">
            {this.props.payment.reasonRemainingBalance}
          </span>
        </div>
      </div>
    );
  }
}

export default CreditsPaymentDetailsTableMobile;
